<template>
    <dialog-modal
        :is-processing="form.processing"
        :primary-button-label="trans('general.action.create')"
        :scrollable="false"
        :show="show"
        @close="$emit('cancel')"
        @submit="handleSubmit"
    >
        <template #title>{{ trans('models.modal.add_model.title') }}</template>

        <form @submit.prevent="handleSubmit">
            <row>
                <column>
                    <div class="d-flex w-100">
                        <jet-input
                            v-model="form.designation"
                            :autofocus="show"
                            :invalidFeedback="form.errors.designation"
                            :label="trans('models.field.designation.label')"
                            :placeholder="
                                trans('models.field.designation.placeholder')
                            "
                            :required="true"
                            style="flex-grow: 1"
                        >
                        </jet-input>
                    </div>
                </column>
            </row>
            <row class="mt-4">
                <column>
                    <jet-select
                        v-model="form.type"
                        :invalidFeedback="form.errors.type"
                        :label="trans('models.field.type.label')"
                        :options="types"
                        :required="true"
                        style="flex-grow: 1"
                    >
                        <template
                            #selectedValue="{ selectedItem, placeholder }"
                        >
                            <div
                                class="d-flex justify-content-between align-items-center gap-3 me-10"
                            >
                                <span>{{
                                    selectedItem?.label || placeholder
                                }}</span
                                ><small class="text-muted">{{
                                    selectedItem?.value
                                }}</small>
                            </div>
                        </template>
                        <template #item-label="{ option }">
                            <div
                                class="d-flex justify-content-between align-items-center gap-3"
                            >
                                <span>{{ option.label }}</span
                                ><small class="text-muted">{{
                                    option.value
                                }}</small>
                            </div>
                        </template>
                    </jet-select>
                </column>
            </row>
        </form>
    </dialog-modal>
</template>
<script>
import DialogModal from '@/Jetstream/DialogModal.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetSelect from '@/Jetstream/Select.vue';
import { $http } from '@/bootstrap.js';

export default {
    components: { DialogModal, JetButton, JetInput, JetSelect },
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        types: {
            type: Array,
        },
        manufacturer_id: {
            type: String,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                type: null,
                designation: null,
            }),
        };
    },

    watch: {
        show(newShow) {
            this.form.clearErrors().reset();
        },
    },

    methods: {
        handleSubmit(event) {
            event.preventDefault();

            if (this.form.processing) {
                return;
            }

            let data = Object.assign({}, this.form.data(), {
                manufacturer_id: this.manufacturer_id,
            });

            this.form.processing = true;

            $http
                .post(route('models.store'), data)
                .then((response) => {
                    this.$emit('success', response.data);
                })
                .catch((error) => {
                    this.form.clearErrors();
                    let errors = {};

                    Object.keys(error.response.data.errors).map((key) => {
                        errors[key] = error.response.data.errors[key][0];
                    });

                    this.form.errors = errors;
                })
                .finally(() => {
                    this.form.processing = false;
                });
        },
    },
};
</script>
